// src/App.jsx
import React from "react";
import "./styles/global.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import RestaurantDashboard from "./components/RestaurantDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "react-hot-toast";
import MultiPrinterConfig from "./components/printer/MultiPrinterConfig";

// Sidebar Component
export const Sidebar = ({
  isMobile,
  isSidebarOpen,
  currentView,
  setIsSidebarOpen,
  setCurrentView,
  onLogout,
}) => {
  const menuItems = [
    { view: "camarero", icon: Users, text: "Modo Camarero" },
    { view: "mesas", icon: LayoutGrid, text: "Mesas" },
    { view: "mostrarMesas", icon: Store, text: "Mostrar Mesas" },
    { view: "categorias", icon: Tags, text: "Categorías" },
    { view: "admCategorias", icon: Settings, text: "Adm. Categorías" },
    { view: "productos", icon: ShoppingBag, text: "Productos" },
    { view: "admProductos", icon: Settings, text: "Adm. Productos" },
    // { view: "barra", icon: Wine, text: "Barra" },
    // { view: "cocina", icon: ChefHat, text: "Cocina" },
    // { view: "historico", icon: History, text: "Histórico" },
  ];

  const handleLogout = () => {
    onLogout();
  };

  return (
    <aside
      className={`
        fixed top-0 left-0 h-screen bg-white shadow-lg 
        transform transition-transform duration-200 ease-in-out 
        ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
        ${isMobile ? "w-full md:w-64" : "w-64"}
        z-20
      `}
    >
      <Toaster position="top-right" />
      <div className="p-4 border-b flex justify-between items-center bg-orange-500">
        <h2 className="text-xl font-bold text-white">Order App</h2>
        {isMobile && (
          <button
            className="text-white hover:bg-orange-600 p-2 rounded"
            onClick={() => setIsSidebarOpen(false)}
          >
            <X className="h-5 w-5" />
          </button>
        )}
      </div>

      <nav className="p-4">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.view}>
              <button
                className={`w-full flex flex-row-reverse justify-between hover:bg-orange-100 p-2 rounded
                  ${
                    currentView === item.view
                      ? "bg-orange-100 text-orange-600"
                      : ""
                  }`}
                onClick={() => {
                  setCurrentView(item.view);
                  if (isMobile) setIsSidebarOpen(false);
                }}
              >
                <item.icon className="h-4 w-4" />
                {item.text}
              </button>
            </li>
          ))}
          <li>
            <button
              className="w-full flex flex-row-reverse text-red-600 hover:bg-red-50 p-2 rounded"
              onClick={handleLogout}
            >
              <LogOut className="ml-2 h-4 w-4" />
              Cerrar Sesión
            </button>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

const App = () => {
  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/registro" element={<Register />} />
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <RestaurantDashboard />
            </ProtectedRoute>
          }
        />
        {/* <Route path="/configuracion" element={<PrinterConfig />} /> */}
        <Route
          path="/configuracionMultiplesImpresoras"
          element={<MultiPrinterConfig />}
        />
      </Routes>
    </Router>
  );
};

export default App;
